import { __extends } from "tslib";
import classnames from 'classnames';
import React from 'react';
var ButtonGroup = (function (_super) {
    __extends(ButtonGroup, _super);
    function ButtonGroup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClick = function (value) {
            var onClick = _this.props.onClick;
            onClick(value);
        };
        return _this;
    }
    ButtonGroup.prototype.render = function () {
        var buttons = this.props.buttons;
        if (!buttons || buttons.length < 1) {
            return null;
        }
        return (React.createElement("div", { className: 'rb-btn-group' }, this.renderButtons()));
    };
    ButtonGroup.prototype.renderButtons = function () {
        var _this = this;
        var _a = this.props, buttons = _a.buttons, selected = _a.selected;
        if (!buttons || buttons.length < 1) {
            return null;
        }
        return buttons.map(function (button, index) {
            if (!button || !button.value) {
                return null;
            }
            return (React.createElement("button", { key: index, className: classnames({
                    btn: true,
                    'btn-active': selected === button.value,
                }), onClick: function () { return _this.onClick(button.value); } }, button.label || button.value));
        });
    };
    return ButtonGroup;
}(React.PureComponent));
export { ButtonGroup };
